// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Sx89","colMaxWidth":"Table_colMaxWidth__2ZFAf"};